import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '@pg-env/environment';

@Injectable({
  providedIn: 'root'
})
export class DetailedTradeHistoryService {
  api: string;

  constructor(private http: HttpClient) {
    this.api = environment.customerApiUrl;
  }

  getTradeHistoryDetail(data: any): Observable<any> {
    return this.http.post(`${this.api}/trade/get-trade-history-detail`, data);
  }

  exportExcel(data: any): Observable<any> {
    return this.http.post(`${this.api}/trade/export-trade-history-detail`, data, { responseType: 'blob' });
  }

  public getTradeTypes(): Observable<any> {
    return this.http.get<any>(`${this.api}/TradeType/trade-types`);
  }
}
